
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const { Container } = require('react-bootstrap');

function Middle (props){
return(
    <Container>                  
        <Row noGutters={true} lg={14} className="block b-color " >
            <img className="banner-img" src={require('../images/backBanner.PNG')} alt="banner"/>
        </Row>
    </Container>
)

}
export default Middle;